<template>
    <div>
        <div class="Slider__container">
            <div class="SearchBlocks">
                <div class="SearchBlocks__tabs">
                    <button type="button" @click="activeTab='learners'" :class="{'is-active': activeTab === 'learners'}"
                            class="SearchBlocks__tabs-item js-search-block-item">
                        Apprenants
                    </button>
                    <button type="button" @click="activeTab='companies'"
                            :class="{'is-active': activeTab === 'companies'}"
                            class="SearchBlocks__tabs-item js-search-block-item">
                        Entreprises
                    </button>
                </div>
                <div v-show="!isMobile || activeTab === 'learners'"
                     class="SearchBlock SearchBlock--learner is-active">
                    <h2 class="SearchBlock__title">
                        <span>Apprenants</span>
                    </h2>
                    <button @click="openCalculator('learners')" class="SearchBlock__calculator">
                        <span>Calculer ma rémunération</span>
                        <i class="SearchBlock__calculator-icon fas fa-calculator"></i>
                    </button>
                    <div class="SearchBlock__body">
                        <div class="SearchBlock__form">
                            <p class="SearchBlock__text">
                                Vous êtes apprenant et vous recherchez une entreprise, consultez nos offres sur la
                                carte.
                            </p>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="Form__group">
                                        <label>Niveaux</label>
                                        <div class="Form__select">
                                            <multiselect
                                                class="Select Select--small"
                                                open-direction="bottom"
                                                :allow-empty="false"
                                                :searchable="false"
                                                :showLabels="false"
                                                :options="companiesLevels"
                                                v-model="companiesLevel"
                                                label="name">
                                                <span slot="noOptions">Aucun élément.</span>
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="Form__group">
                                        <label>Formations</label>
                                        <div class="Form__select">
                                            <multiselect
                                                class="Select Select--small"
                                                open-direction="bottom"
                                                :allow-empty="false"
                                                :searchable="false"
                                                :showLabels="false"
                                                :options="companiesFormations"
                                                v-model="companiesFormation"
                                                label="name">
                                                <span slot="noOptions">Aucun élément.</span>
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xs-12">
                                    <div class="Form__group SearchBlock__zip">
                                        <label for="zip" class="hidden-md">Code postal</label>
                                        <input name="zip" id="zip" v-model="companiesZip"
                                               class="Form__input text-center js-students-zip"
                                               placeholder="Code postal"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="SearchBlock__sidebar">
                            <button @click.prevent="openInformationModal" class="SearchBlock__support js-information">
                                <i class="SearchBlock__support-icon fas fa-headset"></i>
                                <span>J'ai besoin d'un renseignement</span>
                            </button>
                            <button @click="search('COMPANY', companiesZip, companiesLevel, companiesFormation)"
                                    type="submit"
                                    class="SearchBlock__submit Btn Btn--primary Btn--block js-search-companies">Chercher
                            </button>
                        </div>
                    </div>
                </div>
                <div v-show="!isMobile || activeTab === 'companies'"
                     class="SearchBlock SearchBlock--company SearchBlock--reverse is-active">
                    <h2 class="SearchBlock__title">
                        <span>Entreprises</span>
                    </h2>
                    <button @click="openCalculator('companies')" class="SearchBlock__calculator">
                        <i class="SearchBlock__calculator-icon fas fa-calculator"></i>
                        <span>Calculer mes aides</span>
                    </button>
                    <div class="SearchBlock__body">
                        <div class="SearchBlock__form">
                            <p class="SearchBlock__text">
                                Vous êtes une entreprise et vous recherchez des apprenants, consultez nos offres sur la
                                carte.
                            </p>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="Form__group">
                                        <label>Niveaux</label>
                                        <div class="Form__select">
                                            <multiselect
                                                class="Select Select--small"
                                                open-direction="bottom"
                                                :allow-empty="false"
                                                :searchable="false"
                                                :showLabels="false"
                                                :options="learnerLevels" v-model="learnerLevel"
                                                label="name">
                                                <span slot="noOptions">Aucun élément.</span>
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="Form__group">
                                        <label>Formations</label>
                                        <div class="Form__select">
                                            <multiselect
                                                class="Select Select--small"
                                                open-direction="bottom"
                                                :allow-empty="false"
                                                :searchable="false"
                                                :showLabels="false"
                                                :options="learnerFormations"
                                                v-model="learnerFormation"
                                                label="name">
                                                <span slot="noOptions">Aucun élément.</span>
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xs-12">
                                    <div class="Form__group SearchBlock__zip">
                                        <label for="zip" class="hidden-md">Code postal</label>
                                        <input v-model="learnerZip" name="zip"
                                               class="Form__input text-center js-companies-zip"
                                               placeholder="Code postal"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="SearchBlock__sidebar">
                            <button @click.prevent="openFilingAdModal" class="SearchBlock__post">
                                <i class="SearchBlock__post-icon fas fa-map-marked-alt"></i>
                                <span>Je dépose une annonce</span>
                            </button>
                            <button @click.prevent="openAppointmentModal"
                                    class="SearchBlock__appointment js-appointment">
                                <i class="SearchBlock__appointment-icon fas fa-calendar-alt"></i>
                                <span>Je souhaite un rendez&#8209;vous</span>
                            </button>
                            <button @click="search('LEARNER', learnerZip, learnerLevel, learnerFormation)" type="submit"
                                    class="SearchBlock__submit Btn Btn--primary Btn--block js-search-students">Chercher
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="AdsMap">
            <GmapMap

                :center="{
                lat: 46.631299,
                lng: 2.455984
            }"
                ref="mapRef"
                :options="mapOptions"
                :zoom="6"
                style="width: 100%; height: 600px"
                @click="infoWinOpen=false"
            >
                <GmapInfoWindow :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen"
                                @closeclick="infoWinOpen=false">
                    <div class="WhishesPopup" v-if="selectedAd">
                        <div class="WhishesPopup__header">
                            <h2 class="WhishesPopup__name">{{selectedAd.name}}</h2>
                            <div class="WhishesPopup__actions">
                                <button target="_blank"
                                        v-if="selectedAd.type === 'LEARNER' && (!$user || $user.type === $enums.UserType.COMPANY)"
                                        @click="openContract(selectedAd)"
                                        class="Btn Btn--small Btn--primary Btn--with-addon m-r-5">
                                    <span class="Btn__addon"><i class="fas fa-file-contract"></i></span>
                                    Pré-contrat
                                </button>
                                <button type="button" class="Btn Btn--small Btn--primary"
                                        @click.prevent="openModal(selectedAd)">
                                    Contactez-nous
                                </button>
                            </div>
                        </div>
                        <ul class="WhishesPopup__list">
                            <li v-for="formation in formations">{{formation}}</li>
                        </ul>
                    </div>
                </GmapInfoWindow>
                <GmapCluster :styles="clusterStyle" :maxZoom="11" :minimumClusterSize="4" :ignoreHidden="true"
                             imagePath="/images/learners/"
                             :zoomOnClick="true">
                    <GmapMarker
                        :key="index"
                        :visible="visibleAds.includes(ad.code)"
                        v-for="(ad, index) in ads.filter(ad => ad.type === 'LEARNER')"
                        :position="{lat: ad.lat, lng:ad.lng}"
                        :clickable="true"
                        :icon="markerStudent"
                        @click="toggleInfoWindow(ad, ad.code)"
                    />
                </GmapCluster>
                <GmapCluster :maxZoom="11" :minimumClusterSize="4" :ignoreHidden="true"
                             imagePath="/images/companies/"
                             :zoomOnClick="true">
                    <GmapMarker
                        :key="index"
                        :visible="visibleAds.includes(ad.code)"
                        v-for="(ad, index) in ads.filter(ad => ad.type === 'COMPANY')"
                        :position="{lat: ad.lat, lng:ad.lng}"
                        :clickable="true"
                        :icon="markerCompany"
                        @click="toggleInfoWindow(ad, ad.code)"
                    />
                </GmapCluster>
            </GmapMap>
            <div class="AdsMap__view">
                <div class="AdsMap__view-item AdsMap__view-item--learners">
                    Entreprises
                </div>
                <div class="AdsMap__view-item AdsMap__view-item--companies">
                    Apprenants
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Api from "../services/Api";
    import markerStudent from "../../img/marker-student.png";
    import markerCompany from "../../img/marker-company.png";
    import uniqBy from 'lodash.uniqby';
    import styles from '../lib/map-style';
    import ModalBus from "../eventBus";
    import AppointmentModal from "./Modals/Contact/AppointmentModal";
    import AdContactModal from "./Modals/Contact/AdContactModal";
    import ContactModal from "./Modals/Contact/ContactModal";
    import Token from "../services/Token";


    export default {
        components: {},
        data: function () {
            let stylesLearner = {
                fontWeight: "600",
                textColor: "black",
                textDecoration: "none",
                backgroundPosition: "0 0"
            };
            return {
                clusterStyle: [
                    {
                        ...stylesLearner,
                        height: 52,
                        width: 53,
                        url: '/images/learners/1.png',
                        textColor: 'white'
                    },
                    {
                        ...stylesLearner,
                        height: 55,
                        width: 56,
                        url: '/images/learners/2.png',
                        textColor: 'white'
                    },
                    {
                        ...stylesLearner,
                        height: 65,
                        width: 66,
                        url: '/images/learners/3.png',
                        textColor: 'white'
                    },
                    {
                        ...stylesLearner,
                        height: 77,
                        width: 78,
                        url: '/images/learners/4.png',
                        textColor: 'white'
                    },
                    {
                        ...stylesLearner,
                        height: 89,
                        width: 90,
                        url: '/images/learners/5.png',
                        textColor: 'white'
                    }
                ],
                activeTab: 'learners',
                ads: [],
                learnerZip: '',
                learnerFormation: {
                    code: 'ALL',
                    name: 'Toutes'
                },
                learnerLevel: {
                    id: 'ALL',
                    name: 'Tous'
                },
                companiesZip: '',
                companiesFormation: {
                    code: 'ALL',
                    name: 'Toutes'
                },
                companiesLevel: {
                    id: 'ALL',
                    name: 'Tous'
                },
                isMobile: false,
                infoWindowPos: null,
                selectedAd: null,
                infoWinOpen: false,
                currentMidx: null,
                visibleAds: [],
                mapOptions: {
                    styles,
                    center: {
                        lat: 46.631299,
                        lng: 2.455984
                    },
                    mapTypeControl: false,
                    clickableIcons: false,
                    zoom: 6,
                    maxZoom: 14,
                    streetViewControl: false
                },
                infoOptions: {
                    //optional: offset infowindow so it visually sits nicely on top of our marker
                    pixelOffset: {
                        width: 0,
                        height: -35
                    }
                }
            };
        },
        watch: {
            visibleAds: function () {
                //this.fitMap();
            }
        },
        computed: {
            learnerLevels() {
                return this.getLevels('LEARNER');
            },
            learnerFormations() {
                return this.getFormations('LEARNER', this.learnerLevel);
            },
            companiesLevels() {
                return this.getLevels('COMPANY');
            },
            companiesFormations() {
                return this.getFormations('COMPANY', this.companiesLevel);
            },
            markerCompany: () => markerCompany,
            markerStudent: () => markerStudent,
            formations: function () {
                return this.selectedAd?.wishes.map(wish => {
                    let name = wish.formation.name,
                        label = [
                            wish.site?.name,
                            wish.certification?.name,
                            wish.year?.name
                        ].filter(i => i).join(' - ');

                    return `${name} (${label})`;
                });
            }
        },
        methods: {
            openContract(ad) {
                if (!this.$user) {
                    this.$root.openAuthModal();
                    return;
                }

                let url = ad.contract_pdf_uri + '?token=' + Token.get();
                window.open(url);
            },
            getLevels(type) {
                let levels = this.ads
                    .filter(ad => ad.type === type)
                    .flatMap(ad => {
                        return ad.wishes.map(wish => ({
                            ...wish.certification,
                            name: wish.certification.name + ' ' + wish.certification.subtitle
                        }));
                    })
                    .sort((a, b) => a.name > b.name ? 1 : -1);

                return [
                    {
                        id: 'ALL',
                        name: 'Tous'
                    },
                    ...uniqBy(levels, 'id')
                ];
            },
            checkMobile: function () {
                this.isMobile = window.innerWidth <= 1300;
            },
            getFormations(type, level) {
                let diplomes = this.ads
                    .filter(ad => ad.type === type)
                    .flatMap(ad => {
                        return ad.wishes.map(wish => ({
                            ...wish.diplome,
                            level: wish.certification
                        }));
                    })
                    .filter(diplome => level.id === 'ALL' || diplome.level.id === level.id);

                diplomes = uniqBy(diplomes, 'code')
                    .map(diplome => {
                        diplome.formations = this.ads.filter(ad => ad.type === type).flatMap(ad => {
                            return ad.wishes
                                .filter(wish => wish.diplome.code === diplome.code)
                                .map(wish => wish.formation)
                        }).sort((a, b) => a.name > b.name ? 1 : -1);

                        diplome.formations = uniqBy(diplome.formations, 'code');

                        return diplome;
                    })
                    .sort((a, b) => a.name > b.name ? 1 : -1);


                let items = [
                    {
                        code: 'ALL',
                        name: 'Toutes'
                    }
                ];

                diplomes.forEach(diplome => {
                    items.push({
                        code: diplome.code,
                        name: diplome.name,
                        $isDisabled: true
                    });

                    items = [...items, ...diplome.formations];
                });

                return items;

            },
            search: function (type, zip, level, formation) {
                this.visibleAds = this.ads
                    .filter(ad => ad.type === type)
                    .filter(ad => {
                        let isGoodZip = !zip || zip.length < 2 ? true : zip.substr(0, 2) === ad.address.zip.substr(0, 2),
                            isGoodLevel = level.id === 'ALL',
                            isGoodFormation = formation.code === 'ALL';

                        ad.wishes.forEach(wish => {
                            if (wish.certification.id.toString() === level.id.toString()) {
                                isGoodLevel = true;
                            }

                            if (wish.formation.code.toString() === formation.code.toString()) {
                                isGoodFormation = true;
                            }
                        });

                        return isGoodZip && isGoodLevel && isGoodFormation;
                    })
                    .map(ad => ad.code);
            },
            openAppointmentModal() {
                if (window.companies_appointment_link){
                    window.open(window.companies_appointment_link);
                    return;
                }

                ModalBus.open({component: AppointmentModal, props: {}})
            },
            openFilingAdModal() {
                if (window.companies_new_ad_link){
                    window.open(window.companies_new_ad_link);
                    return;
                }

                ModalBus.open({
                    component: ContactModal,
                    props: {
                        title: 'Je dépose une annonce',
                        type: this.$enums.ContactType.FilingAd
                    }
                })
            },
            openInformationModal() {
                if (window.learners_info_link){
                    window.open(window.learners_info_link);
                    return;
                }

                ModalBus.open({
                    component: ContactModal,
                    props: {
                        title: "J'ai besoin d'un renseignement",
                        type: this.$enums.ContactType.Information,
                        subjects: [
                            'Sujet',
                            'Formations',
                            'Diplômes',
                            'Infos pratiques',
                            'Autres'
                        ]
                    }
                })
            },
            openModal: function () {
                if (this.selectedAd.contact_link){
                    window.open(this.selectedAd.contact_link);
                    return;
                }

                ModalBus.open({component: AdContactModal, props: {ad: this.selectedAd}})
            },
            openCalculator: function (type) {
                ModalBus.alert(
                    'Acceder au simulateur',
                    "En cliquant &laquo; continuer &raquo;, vous serez redirigé sur le simulateur de calcul des rémunérations et d'aides aux employeurs.",
                    {
                        icon: 'fas fa-info',
                        closeButton: false,
                        buttons: [
                            {
                                label: 'Fermer',
                                class: 'Btn Btn--stroked',
                                onClick: () => ModalBus.close()
                            },
                            {
                                label: 'Continuer <i class="fas fa-caret-right m-l-5"></i>',
                                class: 'Btn Btn--gradient Btn--shadow',
                                onClick: () => {
                                    let url = type === 'learners'
                                        ? 'https://www.lapprenti.com/html/apprenti/salaires_branches.asp'
                                        : 'https://www.alternance.emploi.gouv.fr/portail_alternance/jcms/gc_5504/simulateur-employeur';
                                    window.open(url);
                                    ModalBus.close();
                                }
                            }
                        ]
                    }
                )
            },
            toggleInfoWindow: function (marker, idx) {
                this.infoWindowPos = {
                    lat: marker.lat,
                    lng: marker.lng
                };

                this.selectedAd = marker;

                if (this.currentMidx === idx) {
                    this.infoWinOpen = !this.infoWinOpen;
                } else {
                    this.infoWinOpen = true;
                    this.currentMidx = idx;
                }
            },
            fitMap: function () {
                this.$refs.mapRef.$mapPromise.then((map) => {
                    let ads = this.ads.filter(ad => this.visibleAds.includes(ad.code)),
                        bounds = new google.maps.LatLngBounds();

                    ads.forEach(ad => {
                        bounds.extend(new google.maps.LatLng(ad.lat, ad.lng));
                    });

                    map.fitBounds(bounds);
                });
            }
        },
        async created() {
            const {data} = await Api.get('/announcements');
            this.ads = data;
            this.visibleAds = data.map(ad => ad.code)

            window.addEventListener('resize', this.checkMobile);
            this.checkMobile();
        },
        mounted() {
            //this.fitMap();
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.checkMobile);
        }
    }
</script>
